import React, { Component, useEffect, useState } from "react";
import DashboardPageHeader from "./DashboardPageHeader";
import LineChart from "../Charts/line";
import BarChart from "../Charts/bar";
import { Card, Accordion } from "react-bootstrap";
import ApplicationStatics from "./ApplicationStatics";
import { getCurrentUser } from "../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAppTasks, getAllAppTasksByMonth, getDashboardReportByMonth,
  getDashboardReportByMonth1,
  getDashboardReportData, getWfPhases, loadAllAppTasks, loadAllAppTasksByMonth,
  loadDashboardReportByMonth, loadDashboardReportByMonth1, loadDashboardReportData, loadWfPhases
} from "../app/store/dashboard";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getAllYears } from "../services/appService";

const Dashboard = () => {

  const [wfPhaseType, setWfPhaseType] = useState("WF Phases");
  const [workflowPhases, setWorkflowPhases] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [applicationByMonth, setApplicationByMonth] = useState(null);
  const [applicationByMonth1, setApplicationByMonth1] = useState(null);
  const [allAppTasks, setAllAppTasks] = useState([]);
  const [allAppTasksByMonth, setAllAppTasksByMonth] = useState([]);
  const [onboardingLineYear, setOnboardingLineYear] = useState(new Date().getFullYear());
  const [onboardingBarYear, setOnboardingBarYear] = useState(new Date().getFullYear());
  const [onboardingWfBarYear, setOnboardingWfBarYear] = useState(new Date().getFullYear());
  const [onboardingWfYear, setOnboardingWfYear] = useState(new Date().getFullYear());


  const wfPhasesSelector = useSelector(getWfPhases);
  const dashboardReportDataSelector = useSelector(getDashboardReportData);
  const dashboardReportByMonthSelector = useSelector(getDashboardReportByMonth);
  const dashboardReportByMonth1Selector = useSelector(getDashboardReportByMonth1);
  const allAppTasksSelector = useSelector(getAllAppTasks);
  const allAppTasksByMonthSelector = useSelector(getAllAppTasksByMonth);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const years = getAllYears();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Dashboard"));
    dispatch(setCurrentRoute([]));
  }, []);

  useEffect(() => {
    //dispatch(loadWfPhases(wfPhaseType));
    dispatch(loadDashboardReportData());

    setTimeout(() => {
      dispatch(loadDashboardReportByMonth(onboardingLineYear));
    }, 1000);

    setTimeout(() => {
      dispatch(loadDashboardReportByMonth1(onboardingBarYear));
    }, 2000);

    setTimeout(() => {
      dispatch(loadAllAppTasks(onboardingWfYear));
    }, 3000);

    setTimeout(() => {
      dispatch(loadAllAppTasksByMonth(onboardingWfBarYear));
    }, 4000);

  }, []);

  useEffect(() => {
    if (wfPhasesSelector.length > 0) {
      const filterWfPhases = wfPhasesSelector.
        filter(x => x.name !== "Enrollment"
          && x.name !== "Exit Survey"
          && x.name !== "Close"
          && x.name !== "Contract Document"
          && x.name !== "Invoice")
      setWorkflowPhases(filterWfPhases);
    }
  }, [wfPhasesSelector]);

  useEffect(() => {
    setDashboardData(dashboardReportDataSelector);
  }, [dashboardReportDataSelector]);

  useEffect(() => {
    setApplicationByMonth(dashboardReportByMonthSelector);
  }, [dashboardReportByMonthSelector]);

  useEffect(() => {
    setApplicationByMonth1(dashboardReportByMonth1Selector);
  }, [dashboardReportByMonth1Selector]);

  useEffect(() => {
    if (allAppTasksSelector) {
      const filterTasks = allAppTasksSelector.filter(x => x.wfPhase !== "Enrollment"
        && x.wfPhase !== "Exit Survey"
        && x.wfPhase !== "Close"
        && x.wfPhase !== "Contract Document"
        //&& x.wfPhase !== "Invoice"
        && x.wfPhase !== "Onboarding / Enrollment"
        && x.wfPhase !== "Review"
        && x.wfPhase !== "Application");
      setAllAppTasks(filterTasks);
    }

  }, [allAppTasksSelector]);

  useEffect(() => {
    console.log(allAppTasksByMonthSelector, "allAppTasksByMonthSelector")
    if (allAppTasksByMonthSelector) {
      const filterTasks = allAppTasksByMonthSelector?.filter(x => x.type !== "Enrollment"
        && x.type !== "Exit Survey"
        && x.type !== "Close"
        && x.type !== "Contract Document"
        //&& x.wfPhase !== "Invoice"
        && x.type !== "Onboarding / Enrollment"
        && x.type !== "Review"
        && x.type !== "Application");
        setAllAppTasksByMonth(filterTasks);
    }
  }, [allAppTasksByMonthSelector]);

  const handleSelect = (e) => {
    //this.setState({ selectedKey: e });
  };

  const getWfPhasesItem = (name) => {
    const count = allAppTasks.filter(
      (x) => x.workflowPhase === name
    ).length;
    
    if (count !== 0) {
      console.group(allAppTasks, "allapptask")
      console.group(name, "name")
      console.group(count, "count")
    }

    const color = getWfPhaseClassName(name);
    const total = allAppTasks.length || 1;
    const percentage = Math.round((count / total) * 100)

    return (
      <li className="list-group-item px-0">
        <div className="row align-items-center">
          <div className="col-auto">
            <span className={`avatar rounded-circle bg-${color}`}></span>
          </div>
          <div className="col">
            <h5>
              {name} ({count})
            </h5>
            <div className="progress progress-sm mb-0">
              <div
                className={`progress-bar bg-${color}`}
                role="progressbar"
                aria-valuenow={30}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{ width: `${percentage}%` }}
              />
            </div>
          </div>
        </div>
      </li>
    );
  }

  const getWfPhaseClassName = (name) => {
    // eslint-disable-next-line default-case
    switch (name) {
      case "Application":
        return "bg-primary";
      case "Onboarding":
        return "btn-wf2-default";
      case "Review":
        return "bg-yellow";
      case "Pending":
        return "bg-info";
      case "Approved":
        return "btn-wf3-default";
      case "Denied":
        return "bg-danger";
      case "Rejected":
        return "bg-danger";
      case "Withdrawn":
        return "bg-warning";
      case "Closed":
        return "bg-default";
      case "Compliance":
        return "btn-wf5-default";
      case "Time Log":
        return "btn-wf6-default";
      case "Invoice":
        return "btn-wf6-default";
      case "Underwriting Phase":
        return "lighter";
    }
  }

  const handleChangeOnboardingLineYear = (e) => {
    setOnboardingLineYear(e.target.value);
    dispatch(loadDashboardReportByMonth(e.target.value));
  }

  const handleChangeOnboardingBarYear = (e) => {
    setOnboardingBarYear(e.target.value);
    dispatch(loadDashboardReportByMonth1(e.target.value));
  }
  const handleChangeOnboardingWfYear = (e) => {
    setOnboardingWfYear(e.target.value);
    dispatch(loadAllAppTasks(e.target.value));
  }

  const handleChangeOnboardingWfBarYear = (e) => {
    console.log(e.target.value, "onboardingWfBarYear")
    setOnboardingWfBarYear(e.target.value);
    dispatch(loadAllAppTasksByMonth(e.target.value));
  }

  return (
    <React.Fragment>
      <div className="col-md-12 mt-3">
        <h2 className="visually-hidden">{"Application"}</h2>
        <h3 className="visually-hidden">{"Application"}</h3>
        {dashboardData &&
          <DashboardPageHeader
            dashboardData={dashboardData}
          ></DashboardPageHeader>}

        <div className="row mb-4 mt-3">
          <div className="col-xl-7">
            <div className="card shadow-none border mb-0">
              <div className="card-header bg-transparent">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <h5 className="text-muted text-uppercase ls-1 mb-1">
                      Subcontractor / Recruiter / Candidate Onboarding
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    <select
                      name="onboardingLineYear"
                      id="onboardingLineYear"
                      value={onboardingLineYear}
                      onChange={handleChangeOnboardingLineYear}
                      className="form-control form-control-sm d-inline-block w-auto">
                      <option value="">Year</option>
                      {years.map((y) => (
                        <option value={y.name}>
                          {y.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {applicationByMonth &&
                  <LineChart
                    graphData={applicationByMonth}
                    label={"Candidates"}
                  ></LineChart>}
              </div>
            </div>
          </div>
          <div className="col-xl-5">
            <div className="card shadow-none border mb-0">
              <div className="card-header bg-transparent">
                <div className="row align-items-center">
                  <div className="col-md-9">
                    <h5 className="text-muted text-uppercase ls-1 mb-1">
                      Subcontractor / Recruiter / Candidate Onboarding
                    </h5>
                  </div>
                  <div className="col-md-3 text-right">
                    <select
                      name="onboardingBarYear"
                      id="onboardingBarYear"
                      value={onboardingBarYear}
                      onChange={handleChangeOnboardingBarYear}
                      className="form-control form-control-sm d-inline-block w-auto">
                      <option value="">Year</option>
                      {years.map((y) => (
                        <option value={y.name}>
                          {y.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {applicationByMonth1 &&
                  <BarChart
                    graphData={applicationByMonth1}
                    label={"Candidates"}
                  ></BarChart>}
              </div>
            </div>
          </div>
        </div>

        {currentUser.type === "admin" && (
          <div className="row">
            <div className="col-md-12">
              <Accordion onSelect={handleSelect}>
                <Card className="shadow-none">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="5"
                    className={"p-3 card-header bg-lighter"}
                  >
                    <h4 className="mb-0">
                      Real-time Application Statistics (Run-Time)
                    </h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="5">
                    <div className="col-md-12 pb-4 border">
                      <ApplicationStatics></ApplicationStatics>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <hr />
              </Accordion>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xl-5">
            <div className="card shadow-none border">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-9">
                    <h5 className="text-uppercase text-muted ls-1 mb-1">
                      Onboarding and Project/Staffing Engagement Status - Current
                    </h5>
                  </div>
                  <div className="col-md-3 text-right">

                    <select
                      name="onboardingWfYear"
                      id="onboardingWfYear"
                      value={onboardingWfYear}
                      onChange={handleChangeOnboardingWfYear}
                      className="form-control form-control-sm d-inline-block w-auto">
                      <option value="">Year</option>
                      {years.map((y) => (
                        <option value={y.name}>
                          {y.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>


              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush list my--3">
                  {/* {workflowPhases.map((item) =>
                    getWfPhasesItem(item.name)
                  )} */}
                  {allAppTasks.map(p =>
                    <li className="list-group-item px-0">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <a href="" className={`avatar rounded-circle ${getWfPhaseClassName(p.wfPhase)}`}></a>
                        </div>
                        <div className="col">
                          <h5>
                            {p.wfPhase} ({p.orderNumber})
                          </h5>
                          <div className="progress progress-sm mb-0">
                            <div
                              className={`progress-bar ${getWfPhaseClassName(p.wfPhase)}`}
                              role="progressbar"
                              //aria-valuenow={30}
                              aria-valuemin={0}
                              aria-valuemax={100}
                              style={{ width: `${p.orderNumber > 0 ? Math.round((p.orderNumber / allAppTasks.filter(x => x.wfPhase === "Onboarding")[0].orderNumber) * 100) : 0}%` }}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-7">
            <div className="card shadow-none border mb-0">
              <div className="card-header bg-transparent">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <h5 className="text-uppercase text-muted ls-1 mb-1">
                      Onboarding and Project/Staffing Engagement Status -
                      Current
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    <select
                      name="onboardingWfBarYear"
                      id="onboardingWfBarYear"
                      value={onboardingWfBarYear}
                      onChange={handleChangeOnboardingWfBarYear}
                      className="form-control form-control-sm d-inline-block w-auto">
                      <option value="">Year</option>
                      {years.map((y) => (
                        <option value={y.name}>
                          {y.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {allAppTasksByMonth &&
                  <BarChart
                    graphData={allAppTasksByMonth}
                    label={"Workflow Phases"}
                  ></BarChart>}
              </div>
            </div>
          </div>
        </div>

        {/* {window.location.pathname === "/" && (
          <div className="row">
            <div className="col-xl-12 text-center mb-3 mt-3">
              <a href="/" className="btn btn-outline-default btn-sm mt-1">
                <i
                  className="fa fa-angle-double-right mr-1"
                  aria-hidden="true"
                ></i>
                Continue
              </a>
            </div>
          </div>
        )} */}
      </div>
      {/* <AddSecurityQuestion
        securityShowHide={securityShowHide}
        handleSecurityShowHide={this.handleSecurityShowHide}
        userDetails={userDetails}
      ></AddSecurityQuestion> */}
    </React.Fragment>
  );
}

export default Dashboard;
